import http from "../utils/axios";

// 获取产品列表接口
export const getProductList = data => {
  return http({
    url: "/api/client_product/getProductList", // 接口
    method: "post",
    data: data
  });
};
// 获取公告
export const getNotice = data => {
  return http({
    url: "/api/notice/getNotice", // 接口
    method: "post",
    data: data
  });
};
